"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gmailDownloadAttachment = exports.gmailDownloadAttachmentResultSchema = exports.gmailDownloadAttachmentArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.gmailDownloadAttachmentArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('download-attachment', zod_1.z.object({
    messageId: zod_1.z.string().describe('The ID of the message containing the attachment'),
    attachmentId: zod_1.z.string().describe('The ID of the attachment to download'),
    filename: zod_1.z.string().nullish().describe('Optional name for the downloaded file'),
}));
exports.gmailDownloadAttachmentResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.object({
    type: zod_1.z.literal('file'),
    fileType: zod_1.z.string(),
    filename: zod_1.z.string(),
    source: zod_1.z.object({
        kind: zod_1.z.union([zod_1.z.literal('raw'), zod_1.z.literal('url')]),
        value: zod_1.z.string(),
    }),
}));
exports.gmailDownloadAttachment = (0, common_1.createToolMetadata)({
    id: 'gmailDownloadAttachment',
    displayName: 'Gmail Download Attachment',
    displayDescription: 'Download an attachment from a Gmail message',
    category: 'communication',
    color: common_1.BRAND_COLORS.GMAIL,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GMAIL),
    icon: 'gmail',
    argsSchema: exports.gmailDownloadAttachmentArgsSchema,
}, exports.gmailDownloadAttachmentResultSchema);
